export const INPUT_SUPPORTS_RANGE_SELECTION = ["text", "search", "url", "tel", "password", "textarea"];
export const INPUT_SUPPORTS_SELECTION = [...INPUT_SUPPORTS_RANGE_SELECTION, "number"];
